// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.summary.RentalManagerUserPropertySummaryWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertySummaryApplicationsResponseWebDto,
  UserPropertySummaryLeasesResponseWebDto,
  UserPropertySummaryListingResponseWebDto,
  UserPropertySummaryMaintenanceResponseWebDto,
  UserPropertySummaryNextStepsResponseWebDto,
  UserPropertySummaryPaymentsResponseWebDto,
  UserPropertySummaryPropertyConditionsResponseWebDto,
} from '../..';

interface ApplicationsParams {
  getActive?: boolean;
  listingAlias: ListingAlias;
}
interface LeasesParams {
  listingAlias: ListingAlias;
}
interface ListingParams {
  listingAlias: ListingAlias;
}
interface MaintenanceParams {
  listingAlias: ListingAlias;
}
interface NextStepsParams {
  listingAlias: ListingAlias;
}
interface PaymentsParams {
  listingAlias: ListingAlias;
}
interface PropertyConditionsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertySummaryWebApiHandler_applications_Path =
  '/api/web/v1/users/properties/summary/applications';

/**
 * Listing summary from Applications. To be used for Interested Renters module
 */
export const RentalManagerUserPropertySummaryWebApiHandler_applications = (
  getParams: ApplicationsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ApplicationsParams, never, UserPropertySummaryApplicationsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_applications_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_leases_Path = '/api/web/v1/users/properties/summary/leases';

/**
 * Listing summary from Leases
 */
export const RentalManagerUserPropertySummaryWebApiHandler_leases = (getParams: LeasesParams, client = getClient()) => {
  return httpFrontEndRequest<LeasesParams, never, UserPropertySummaryLeasesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_leases_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_listing_Path =
  '/api/web/v1/users/properties/summary/listing';

/**
 * Get listing summary
 */
export const RentalManagerUserPropertySummaryWebApiHandler_listing = (
  getParams: ListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListingParams, never, UserPropertySummaryListingResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_listing_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_maintenance_Path =
  '/api/web/v1/users/properties/summary/maintenance';

/**
 * Listing summary from maintenance tracker
 */
export const RentalManagerUserPropertySummaryWebApiHandler_maintenance = (
  getParams: MaintenanceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<MaintenanceParams, never, UserPropertySummaryMaintenanceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_maintenance_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Path =
  '/api/web/v1/users/properties/summary/nextSteps';

/**
 * Listing summary next steps
 */
export const RentalManagerUserPropertySummaryWebApiHandler_nextSteps = (
  getParams: NextStepsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<NextStepsParams, never, UserPropertySummaryNextStepsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_nextSteps_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_payments_Path =
  '/api/web/v1/users/properties/summary/payments';

/**
 * Listing summary from Payments
 */
export const RentalManagerUserPropertySummaryWebApiHandler_payments = (
  getParams: PaymentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PaymentsParams, never, UserPropertySummaryPaymentsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_payments_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Path =
  '/api/web/v1/users/properties/summary/propertyConditions';

/**
 * Listing summary from Property Condition
 */
export const RentalManagerUserPropertySummaryWebApiHandler_propertyConditions = (
  getParams: PropertyConditionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PropertyConditionsParams, never, UserPropertySummaryPropertyConditionsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySummaryWebApiHandler_propertyConditions_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
